import { IFetchResult, RequestMethods } from 'networking/fetchConfig';
import { SpacemanResource } from 'types/spacemanTypes';
import { spacemanFetch, SpacemanVerboseResponse } from './spacemanFetch';

type GetResourcesResponse = SpacemanVerboseResponse<SpacemanResource[]>;

export const getResources = (): Promise<IFetchResult<GetResourcesResponse>> =>
  spacemanFetch<GetResourcesResponse>(RequestMethods.GET, `/api/v2/resources`);
